import React, { useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { onDragEnd } from "../resources/utils";

import Media from "../components/Media";

import styles from './Onboard.module.scss';

const variants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    };
  }
};

const Onboard = ({ onboards, onFinish }) => {
  const [[page, direction], setPage] = useState([0, 0]);
  let onboard = onboards[page];

  const paginate = (newDirection: number) => {
    setPage([page + newDirection, newDirection]);
  };
  return (
    <div className={styles.onboardWrapper}>
      <AnimatePresence initial={false} custom={direction}>
        <motion.div
        className={styles.onboard}
        key={page}
        custom={direction}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{
          x: { type: "spring", stiffness: 300, damping: 30 },
          opacity: { duration: 0.2 }
        }}
        drag="x"
        dragConstraints={{ left: 0, right: 0 }}
        dragElastic={0.5}
        onDragEnd={(e, { offset, velocity }) => {
          onDragEnd(
            offset,
            velocity,
            () => {
              if(page > 0) {
                paginate(-1);
              }
            },
            () => {
              if(page === onboards.length - 1) {
                onFinish();
              } else {
                paginate(1);
              }
            },
          )
        }}
        >

          { onboard.title && <h4>{onboard.title}</h4> }
          { onboard.image && <Media image={onboard.image} /> }
          { onboard.text && <p>{decodeURIComponent(onboard.text)}</p> }
          <div data-dots>
            { onboards.map((z, zi) => <span key={zi} onClick={() => { paginate(zi - page); }} data-active-dot={zi === page}></span>) }
          </div>
          <button onClick={() => {
            if(page === onboards.length - 1) {
              onFinish();
            } else {
              paginate(1);
            }
          }} style={{ backgroundColor: onboard.accentColour ? `#${onboard.accentColour}`: undefined}}>
            <span style={{ color: onboard.buttonTextColour ? `#${onboard.buttonTextColour}` : undefined}}>{onboard.buttonText ? onboard.buttonText : 'Next'}</span>
          </button>
        </motion.div>
      </AnimatePresence>
    </div>
  )
}

export default Onboard;
